import find from 'lodash/find';

import RequirementsService from 'common/services/RequirementsService';
import { WorkOrderRequirement, WorkOrder } from 'common/types';
import {
    FilterOption,
    AdvancedFiltersState,
} from 'common/context/DataGridAdvancedFilterContext';

export async function getSiteInspectionRequirements(
    workOrderId: number,
    requirements: WorkOrderRequirement[]
) {
    try {
        const hasSiteInspectionSubmission = find(
            requirements,
            req => req.requirementTypeId === 'EQUIPMENT_SITE_INSPECTION_FORM'
        );
        if (hasSiteInspectionSubmission) {
            const siteInspections =
                await RequirementsService.fetchRequirementsForWorkOrder(
                    workOrderId
                );
            const updatedRequirements = [...requirements];
            for (let i = 0; i < updatedRequirements.length; i++) {
                if (
                    updatedRequirements[i].requirementTypeId ===
                    'EQUIPMENT_SITE_INSPECTION_FORM'
                ) {
                    updatedRequirements[i].requirement = find(
                        siteInspections.data,
                        inspection =>
                            inspection.assetId ===
                            updatedRequirements[i].assetUUID
                    );
                }
            }
            return updatedRequirements;
        }
    } catch (error) {
        console.error(error);
    }
    return requirements;
}

export function hasRelatedWorkOrders(workOrder: WorkOrder) {
    return (
        workOrder?.parentWorkOrder ||
        (workOrder?.childWorkOrders && workOrder.childWorkOrders.length > 0)
    );
}

export const calculateExceptionChildrenChanges = (
    newFilters: { id: string; form?: { id: string; parentId: string } }[],
    advancedFilters: {
        issueReason?: {
            term: string;
            form: { id: string; parentId: string };
        }[];
        issueSecondaryReason?: {
            term: string;
            form: { id: string; parentId: string };
        }[];
    }
) => {
    const currentIssueIds =
        newFilters?.map(issue => (issue.form ? issue.form.id : issue.id)) || [];

    const updatedIssueReasons = advancedFilters.issueReason?.filter(reason =>
        currentIssueIds.includes(reason.form.parentId)
    );
    const updatedIssueReasonIds = updatedIssueReasons?.map(
        reason => reason.form.id
    );
    const updatedIssueSecondaryReasons =
        advancedFilters.issueSecondaryReason?.filter(reason =>
            updatedIssueReasonIds?.includes(reason.form.parentId)
        );

    const updates: {
        issueReason?: typeof updatedIssueReasons;
        issueSecondaryReason?: typeof updatedIssueSecondaryReasons;
    } = {};

    if (
        advancedFilters.issueReason?.map(issue => issue.term) !==
        updatedIssueReasonIds
    ) {
        updates.issueReason = updatedIssueReasons;
    }
    if (
        advancedFilters.issueSecondaryReason?.map(issue => issue.term) !==
        updatedIssueSecondaryReasons
    ) {
        updates.issueSecondaryReason = updatedIssueSecondaryReasons;
    }

    return updates;
};

export const calculateExceptionReasonChildrenChanges = (
    newFilters: { id: string; form?: { id: string; parentId: string } }[],
    advancedFilters: {
        issueSecondaryReason?: { form: { id: string; parentId: string } }[];
    }
) => {
    const currentReasonIds =
        newFilters?.map(issue => (issue.form ? issue.form.id : issue.id)) || [];
    const secondaryReasonChanges = advancedFilters.issueSecondaryReason?.filter(
        reason => currentReasonIds.includes(reason.form.parentId)
    );

    return {
        issueSecondaryReason: secondaryReasonChanges || [],
    };
};
